export default __webpack_public_path__ + "files/0bcd8fb193ae33961ab223c249b98b41.woff2";